const state = {
    currencyConversionTable: null,
    visitorCurrency: null,
};

export default state;